import styled from 'styled-components';
import colors from '../../../../helpers/colors';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { PrimaryCta } from '../../../Cta';
import Icon from '../../../Icon';
import { navItemSelectedBarHeight } from '../../Header/styles';
import {
  navItemSelectedBar,
  NavItemText,
  NavItemWithoutBorder,
  rotateArrowWhenSelected,
} from '../styles';

export const NavItem = styled(NavItemWithoutBorder)`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${navItemSelectedBar(colors.navigationHighlight)}
  ${rotateArrowWhenSelected};

  &:not(:first-child) ${NavItemText} {
    border-left: solid ${colors.neutral08} 1px;
  }

  /* In chrome, the box shadow doesn't completely hide the dividers, so make the relevant
  ones transparent on focus.  */
  &:focus-visible ${NavItemText}, &:focus-visible + button ${NavItemText} {
    border-color: transparent;
  }
`;

export const NavItemArrow = styled(Icon)`
  margin-right: ${spacing(2)};
`;

export const Megamenu = styled.div`
  display: none;

  position: absolute;
  top: calc(100% + ${navItemSelectedBarHeight});
  left: 0;
  width: 100%;

  ${mediaQuery.tabletLandscape`
    display: block;
  `}
`;

export const Menu = styled.div`
  background: ${colors.neutral08};
  border-bottom: 1px ${colors.neutral04} solid;
`;

export const CtaContainer = styled.div`
  background: ${colors.neutral06};
  min-height: ${spacing(7)};
`;

export const CtaWithMargin = styled(PrimaryCta)`
  margin: ${spacing(3)} ${spacing(1)};

  &:first-child {
    margin-left: 0;
  }
`;
